import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { Route, Routes, useSearchParams } from 'react-router-dom';
import style from './CompanyReportsPanel.module.css';
import ReportCardWidget from '../../../widgets/companies/reports/ReportCardWidget/ReportCardWidget';
import ReportsBreadcrumbsWidget from '../../../widgets/companies/reports/ReportsBreadcrumbsWidget/ReportsBreadcrumbsWidget';
import ReportsListWidget from '../../../widgets/companies/reports/ReportsListWidget/ReportsListWidget';
import ReportToolbarWidget from '../../../widgets/companies/reports/ReportToolbarWidget/ReportToolbarWidget';
import ReportTasksTableWidget from '../../../widgets/companies/reports/ReportTasksTableWidget/ReportTasksTableWidget';

// Отображает панель "Отчеты" по компании
function CompanyReportsPanel({ companyId }) {
  const [searchParams] = useSearchParams();
  const reportId = searchParams.get('report');
  return (
    <Routes>
      <Route
        path="*"
        element={
          <Box className={style.panel}>
            <ReportsBreadcrumbsWidget />
            <ReportToolbarWidget reportId={reportId} />
            <Box sx={reportId ? { display: 'none' } : undefined}>
              <ReportsListWidget companyId={companyId} />
            </Box>
            {reportId && <ReportCardWidget companyId={companyId} />}
          </Box>
        }
      />

      <Route path="/report-tasks" element={<ReportTasksTableWidget companyId={companyId} />} />
      <Route path="/report-tasks/edit/:reportTaskId" element={<ReportCardWidget companyId={companyId} />} />
    </Routes>
  );
}

CompanyReportsPanel.propTypes = {
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
};

CompanyReportsPanel.defaultProps = {
  companyId: null,
};

export default CompanyReportsPanel;
